module.exports = __webpack_public_path__ + "static/media/Binoculars.c3bc3b04.png";